/* Footer menus collapse on mobile.

   The three link columns are most of the footer's height on a phone. Each is
   wrapped in a <details> so its heading becomes the toggle, and every group
   is forced open again above the mobile breakpoint - so this only ever hides
   anything on small screens, and never on desktop.

   Wrapping happens once; only the open state changes on resize. */

(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function build() {
    var blocks = document.querySelectorAll('.footer-block--menu');

    Array.prototype.forEach.call(blocks, function (block) {
      if (block.dataset.ctFootAcc) return;

      var heading = block.querySelector('.footer-block__heading');
      var content = block.querySelector('.footer-block__details-content');
      if (!heading || !content) return;

      block.dataset.ctFootAcc = '1';

      var details = document.createElement('details');
      details.className = 'ct-foot-acc';

      var summary = document.createElement('summary');
      summary.appendChild(heading);

      var caret = document.createElement('span');
      caret.className = 'ct-foot-acc__caret';
      caret.setAttribute('aria-hidden', 'true');
      summary.appendChild(caret);

      details.appendChild(summary);
      block.insertBefore(details, content);
      details.appendChild(content);
    });
  }

  function sync() {
    var collapse = window.matchMedia && window.matchMedia(MOBILE).matches;
    var groups = document.querySelectorAll('.ct-foot-acc');

    Array.prototype.forEach.call(groups, function (d) {
      /* Open on desktop, and leave whatever the shopper chose on mobile
         rather than snapping groups shut while they are reading. */
      if (!collapse) d.open = true;
      else if (!d.dataset.ctTouched) d.open = false;
    });
  }

  function init() {
    build();
    sync();

    document.addEventListener('toggle', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('ct-foot-acc')) {
        e.target.dataset.ctTouched = '1';
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', sync, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();